module.exports = __webpack_public_path__ + "img/21.c68e6602.jpg";